import template from './sw-cms-sidebar.html.twig';

Shopware.Component.override('sw-cms-sidebar', {
    template
});
